module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousTruckView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    staticStyle: {
      "margin-left": "0.5rem !important"
    },
    attrs: {
      "center": ""
    }
  }, [_vm._v("Vehicle Form")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.vehicleData.vehicleTruckId != '') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "Type"
    }
  }, [_vm._v("Vehicle Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.vehicleData.vehicleTruckId > 0 &&
        _vm.$sessionsStorage.get('designation') != 'Admin',
      "list": _vm.vehicleStatusList,
      "option-value": "vehicleStatusV",
      "option-text": "vehicleStatusT",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.vehicleData.isTruckMasterActive),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "isTruckMasterActive", $$v)
      },
      expression: "vehicleData.isTruckMasterActive"
    }
  })], 1), _vm._v(" "), (!_vm.vehicleData.driverId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.addTruckError5))]) : _vm._e()], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-2",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Firm Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.vehicleData.vehicleTruckId > 0 &&
        _vm.$sessionsStorage.get('designation') != 'Admin',
      "formatter": _vm.capitalizeAll,
      "id": "vehicleNo",
      "name": "vehicleNo"
    },
    model: {
      value: (_vm.vehicleData.vehicleNo),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "vehicleNo", $$v)
      },
      expression: "vehicleData.vehicleNo"
    }
  })], 1), _vm._v(" "), (!_vm.vehicleData.vehicleNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.addTruckError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Chassis No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.vehicleData.vehicleTruckId > 0 &&
        _vm.$sessionsStorage.get('designation') != 'Admin',
      "formatter": _vm.capitalizeAll,
      "id": "chassisNo",
      "name": "chassisNo"
    },
    model: {
      value: (_vm.vehicleData.chassisNo),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "chassisNo", $$v)
      },
      expression: "vehicleData.chassisNo"
    }
  })], 1), _vm._v(" "), (!_vm.vehicleData.chassisNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.addTruckError3))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vehicle No.(AB-12-A-1234)")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.vehicleData.vehicleTruckId > 0 &&
        _vm.$sessionsStorage.get('designation') != 'Admin',
      "formatter": _vm.capitalizeAll,
      "id": "regdNo",
      "name": "regdNo"
    },
    on: {
      "input": _vm.checkExistingVehicle
    },
    model: {
      value: (_vm.vehicleData.regdNo),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "regdNo", $$v)
      },
      expression: "vehicleData.regdNo"
    }
  }), _vm._v(" "), (_vm.validateSameVehicle == true) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.sameVehicleNoError))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Model No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.vehicleData.vehicleTruckId > 0 &&
        _vm.$sessionsStorage.get('designation') != 'Admin',
      "formatter": _vm.capitalizeAll,
      "id": "modNo",
      "name": "modNo"
    },
    model: {
      value: (_vm.vehicleData.modNo),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "modNo", $$v)
      },
      expression: "vehicleData.modNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Engine No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.vehicleData.vehicleTruckId > 0 &&
        _vm.$sessionsStorage.get('designation') != 'Admin',
      "formatter": _vm.capitalizeAll,
      "id": "engineNo",
      "name": "engineNo"
    },
    model: {
      value: (_vm.vehicleData.engineNo),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "engineNo", $$v)
      },
      expression: "vehicleData.engineNo"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "Type"
    }
  }, [_vm._v("Vehicle Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.vehicleData.vehicleTruckId > 0 &&
        _vm.$sessionsStorage.get('designation') != 'Admin',
      "list": _vm.vehicleTypeMaster,
      "option-value": "vehicleTypeId",
      "option-text": "vehicleType",
      "placeholder": "Select Vehicle Type "
    },
    model: {
      value: (_vm.vehicleData.vehicleTypeId),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "vehicleTypeId", $$v)
      },
      expression: "vehicleData.vehicleTypeId"
    }
  })], 1), _vm._v(" "), (!_vm.vehicleData.vehicleTypeId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.addTruckError1))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "Type"
    }
  }, [_vm._v("Vehicle Size")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.vehicleData.vehicleTruckId > 0 &&
        _vm.$sessionsStorage.get('designation') != 'Admin',
      "list": _vm.vehicleSizeMaster,
      "option-value": "vehicleSizeId",
      "option-text": "vehicleSize",
      "placeholder": "Select Vehicle Size "
    },
    model: {
      value: (_vm.vehicleData.vehicleSizeId),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "vehicleSizeId", $$v)
      },
      expression: "vehicleData.vehicleSizeId"
    }
  })], 1), _vm._v(" "), (!_vm.vehicleData.vehicleSizeId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.addTruckError2))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Year of Purchase")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "disabled": _vm.vehicleData.vehicleTruckId > 0 &&
        _vm.$sessionsStorage.get('designation') != 'Admin',
      "formatter": _vm.capitalizeAll,
      "id": "vmodelYear",
      "name": "vmodelYear"
    },
    model: {
      value: (_vm.vehicleData.vmodelYear),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "vmodelYear", $$v)
      },
      expression: "vehicleData.vmodelYear"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "Type"
    }
  }, [_vm._v("Hub")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.vehicleData.vehicleTruckId > 0 &&
        _vm.$sessionsStorage.get('designation') != 'Admin',
      "list": _vm.hubDetails,
      "option-value": "hubId",
      "option-text": "hubName",
      "placeholder": "Select Hub"
    },
    model: {
      value: (_vm.vehicleData.hubId),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "hubId", $$v)
      },
      expression: "vehicleData.hubId"
    }
  })], 1), _vm._v(" "), (!_vm.vehicleData.driverId) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.addTruckError5))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "Type"
    }
  }, [_vm._v("Vehicle Active/Inactive")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.vehicleData.vehicleTruckId > 0 &&
        _vm.$sessionsStorage.get('designation') != 'Admin',
      "list": _vm.vehicleActiveInactive,
      "option-value": "vehicleActiveInactiveV",
      "option-text": "vehicleActiveInactiveT",
      "placeholder": "Active / Inactive "
    },
    model: {
      value: (_vm.vehicleData.vehicleActiveInactiveId),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "vehicleActiveInactiveId", $$v)
      },
      expression: "vehicleData.vehicleActiveInactiveId"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), (_vm.vehicleData.vehicleTruckId != '') ? _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "Type"
    }
  }, [_vm._v("Vehicle Driver")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "driverId",
      "id": "driverId",
      "disabled": ""
    },
    model: {
      value: (_vm.vehicleData.driverId),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "driverId", $$v)
      },
      expression: "vehicleData.driverId"
    }
  }, [_c('md-option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Select Driver")]), _vm._v(" "), _vm._l((_vm.driverNameDetail), function(item, index) {
    return _c('md-option', {
      key: index,
      attrs: {
        "value": item.driverId
      }
    }, [_vm._v(_vm._s(item.driverName))])
  })], 2)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-4"
  }, [_c('div', [_c('b', [_c('u', [_vm._v("Vehicle Documents")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('table', {
    staticClass: "table table-bordered"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Document Name")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("Upload")]), _vm._v(" "), _c('th', {
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("View Document")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.showDocumentArray), function(items, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(items.show))]), _vm._v(" "), _c('td', [_c('md-input-container', [_c('label', [_vm._v("Click to Upload " + _vm._s(items.show))]), _vm._v(" "), _c('md-file', {
      attrs: {
        "name": items.value,
        "id": items.value,
        "multiple": items.show == 'Other Document' ? true : false
      },
      on: {
        "selected": function($event) {
          _vm.onFileChange(items.value)
        }
      },
      model: {
        value: (_vm.vehicleData[items.value]),
        callback: function($$v) {
          _vm.$set(_vm.vehicleData, items.value, $$v)
        },
        expression: "vehicleData[items.value]"
      }
    })], 1)], 1), _vm._v(" "), _c('td', [(
      items.show != 'Other Document' &&
      _vm.vehicleData[items.value] != ''
    ) ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.openSignedDocument(_vm.getS3Key(items.url, _vm.vehicleData[items.value]))
        }
      }
    }, [_vm._v("View " + _vm._s(items.show))]) : (
      items.show == 'Other Document' &&
      _vm.vehicleData[items.value] != ''
    ) ? _vm._l((_vm.viewVehicledDoc), function(item, index) {
      return _c('div', {
        key: index
      }, [_c('a', {
        attrs: {
          "href": "javascript:void(0)"
        },
        on: {
          "click": function($event) {
            _vm.openSignedDocument(_vm.getS3Key(items.url, item))
          }
        }
      }, [_vm._v("Document - " + _vm._s(index + 1))])])
    }) : _vm._e()], 2)])
  }))])]), _vm._v(" "), _c('b-card', {
    staticClass: "mt-5",
    staticStyle: {
      "background": "whiteSmoke"
    }
  }, [_c('b-card-text', [_c('div', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("National Permit Authorization Validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "Date",
      "width": "100%"
    },
    model: {
      value: (_vm.vehicleData.NPAValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "NPAValidity", $$v)
      },
      expression: "vehicleData.NPAValidity"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("National Permit PART AB Validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "Date",
      "width": "100%"
    },
    model: {
      value: (_vm.vehicleData.NPValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "NPValidity", $$v)
      },
      expression: "vehicleData.NPValidity"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("FITNESS CERTIFICATE Validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "Date",
      "width": "100%"
    },
    model: {
      value: (_vm.vehicleData.FCValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "FCValidity", $$v)
      },
      expression: "vehicleData.FCValidity"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Pollution Certificate Validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "placeholder": "Date",
      "id": "Date",
      "width": "100%"
    },
    model: {
      value: (_vm.vehicleData.polutionValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "polutionValidity", $$v)
      },
      expression: "vehicleData.polutionValidity"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("INSURANCE Validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "placeholder": "Date",
      "id": "Date",
      "width": "100%"
    },
    model: {
      value: (_vm.vehicleData.INValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "INValidity", $$v)
      },
      expression: "vehicleData.INValidity"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("RC Validity")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "placeholder": "Date",
      "id": "Date",
      "width": "100%"
    },
    model: {
      value: (_vm.vehicleData.RCValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "RCValidity", $$v)
      },
      expression: "vehicleData.RCValidity"
    }
  })], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("MV TAX Validity Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "placeholder": "Date",
      "id": "Date",
      "width": "100%"
    },
    model: {
      value: (_vm.vehicleData.MUValidity),
      callback: function($$v) {
        _vm.$set(_vm.vehicleData, "MUValidity", $$v)
      },
      expression: "vehicleData.MUValidity"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-4",
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.vehicleData.National_Permit_Authorization == '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.NPAError))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.vehicleData.National_Permit_PART_AB == '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.NPError))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.vehicleData.FITNESS_CERTIFICATE == '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.FCError))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.vehicleData.INSURANCE == '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.INError))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.vehicleData.MU_TAX == '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.MUError))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.vehicleData.RC == '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.RCError))]) : _vm._e()]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [(_vm.vehicleData.pollutionCertificate == '') ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.pollutionError))]) : _vm._e()])], 1)], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mt-3",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    staticClass: "justify-content-center"
  }, [_c('b-button', {
    staticClass: "smbutnWidth mt-3",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addTruckDetails
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f828b20","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleMaster/truckMaster.vue
// module id = 2441
// module chunks = 0